import { styledWithTheme } from "../../context";
import { Row } from "../../layout";
export var TimeSegmentRow = styledWithTheme(Row)(function (_ref) {
  var selectors = _ref.theme.selectors;
  return {
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: selectors.fontSize('T300'),
    fontFamily: selectors.fontFamily('primary')
  };
});